import React from "react";
import { View } from "react-native";

import { useNavigation } from "@react-navigation/core";

import HeaderDefault from "../../components/HeaderDefault";

import CryptoListSelection from "../../components/CryptoListSelection";

const DepositCryptoSelection = () => {
  const navigation = useNavigation();

  function onCryptoSelected(crypto) {
  const  { acronym,activeId,minValue,name,step} = crypto;
    navigation.navigate({ name: 'DepositCrypto', params: { acronym: acronym,activeId: activeId,minValue: minValue,name:name,step :step} });
  }

  return (
    <View>
      <HeaderDefault title={"Depositar"} />

      <CryptoListSelection onItemPressed={onCryptoSelected} />
    </View>
  );
};

export default DepositCryptoSelection;
